// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fISvo","comment":"styles_comment__9uq72"};